import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import travelMindsLogo from '../../assets/travelminds-logo-h.webp';

type Page = 'home' | 'pricing' | 'faq' | 'help' | 'login' | 'signup' | 'demo';

interface Props {
  current?: Page;
}

const navLinkBase =
  'hidden sm:inline text-sm transition-colors no-underline px-2 py-1';

const PublicNav: React.FC<Props> = ({ current }) => (
  <header className="w-full border-b border-[var(--border)] bg-white">
    <nav className="flex items-center justify-between px-4 sm:px-6 py-3 max-w-6xl mx-auto">
      <Link to="/" className="flex items-end gap-2 no-underline">
        <img src={travelMindsLogo} alt="TravelMinds" className="h-9 sm:h-10 block" />
        <span
          className="text-[1rem] sm:text-[1.1rem] text-[var(--accent)] leading-none mb-[5px]"
          style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 600 }}
        >
          marketing
        </span>
      </Link>
      <div className="flex items-center gap-1 sm:gap-3">
        <NavLink
          to="/pricing"
          className={`${navLinkBase} ${current === 'pricing' ? 'text-[var(--text)] font-medium' : 'text-[var(--text-muted)] hover:text-[var(--text)]'}`}
        >
          Pricing
        </NavLink>
        <NavLink
          to="/faq"
          className={`${navLinkBase} ${current === 'faq' ? 'text-[var(--text)] font-medium' : 'text-[var(--text-muted)] hover:text-[var(--text)]'}`}
        >
          FAQ
        </NavLink>
        <NavLink
          to="/help"
          className={`${navLinkBase} ${current === 'help' ? 'text-[var(--text)] font-medium' : 'text-[var(--text-muted)] hover:text-[var(--text)]'}`}
        >
          Help
        </NavLink>
        {current !== 'login' && current !== 'signup' && (
          <Link
            to="/login"
            className="ml-2 text-sm bg-[var(--primary)] text-white px-4 py-2 rounded hover:bg-[var(--primary-light)] transition-colors no-underline"
          >
            Sign In
          </Link>
        )}
      </div>
    </nav>
  </header>
);

export default PublicNav;
